const linkLandingPagesValidationNL = {
    "add": {
        "title": {
            "required": "Titel is verplicht",
            "length": "Titel mag niet langer zijn dan 32 tekens"
        },
        "short_description": {
            "length": "Beschrijving mag niet langer zijn dan 80 tekens."
        },
        "back_url": {
            "required": "Terug Url is verplicht",
            "length": "Terug Url mag niet langer zijn dan 10 tekens",
            "unique": "Oeps! Deze terug url is al gekoppeld aan een andere landingspagina. Probeer een andere terug url.",
            "available": "Terug url is beschikbaar",
            "invalid": "Terug url is ongeldig"
        },
        "logo": {
            "required": "Logo is verplicht",
            "dimensions": "Logo moet minimaal 500 X 500 px zijn en een beeldverhouding van 1:1 hebben, JPG/JPEG/PNG-formaten worden ondersteund.",
            "choose": "Kies alstublieft een afbeelding",
            "file": "Upload alstublieft JPG- of PNG-formaten, minimale resolutie 500 X 500 px en beeldverhouding 1:1. Max grootte 2MB"
        },
        "background_image": {
            "dimensions": "Achtergrondafbeelding moet minimaal 1000 X 1000 px zijn en een beeldverhouding van 1:1 hebben, JPG/JPEG/PNG-formaten worden ondersteund.",
            "choose": "Kies alstublieft een afbeelding",
            "file": "Upload alstublieft JPG- of PNG-formaten, minimale resolutie 1000 X 1000 px en beeldverhouding 1:1. Max grootte 5MB"
        },
        "social_link_destination_url_facebook": {
            "required": "Bestemmings-Url is verplicht",
            "regexp": "Ongeldige Url",
            "invalid": "Ongeldige Facebook Url"
        },
        "social_link_destination_url_instagram": {
            "required": "Bestemmings-Url is verplicht",
            "regexp": "Ongeldige Url",
            "invalid": "Ongeldige Instagram Url"
        },
        "social_link_destination_url_twitter": {
            "required": "Bestemmings-Url is verplicht",
            "regexp": "Ongeldige Url",
            "invalid": "Ongeldige Twitter Url"
        },
        "social_link_destination_url_youtube": {
            "required": "Bestemmings-Url is verplicht",
            "regexp": "Ongeldige Url",
            "invalid": "Ongeldige Youtube Url"
        },
        "social_link_destination_url_tiktok": {
            "required": "Bestemmings-Url is verplicht",
            "regexp": "Ongeldige Url",
            "invalid": "Ongeldige TikTok Url"
        },
        "social_link_destination_url_linkedin": {
            "required": "Bestemmings-Url is verplicht",
            "regexp": "Ongeldige Url",
            "invalid": "Ongeldige LinkedIn Url"
        },
        "social_link_destination_url_other": {
            "regexp": "Ongeldige Url"
        },
        "featured_link_title": {
            "required": "Label is verplicht",
            "length": "Label mag niet langer zijn dan 100 tekens"
        },
        "featured_link_destination_url": {
            "required": "Bestemmings-Url is verplicht",
            "regexp": "Ongeldige Url"
        }
    },
    "update": {
        "title": {
            "required": "Titel is verplicht",
            "length": "Titel mag niet langer zijn dan 32 tekens"
        },
        "short_description": {
            "length": "Beschrijving mag niet langer zijn dan 80 tekens."
        },
        "back_url": {
            "required": "Terug Url is verplicht",
            "length": "Terug Url mag niet langer zijn dan 10 tekens",
            "unique": "Oeps! Deze terug url is al gekoppeld aan een andere landingspagina. Probeer een andere terug url.",
            "available": "Terug url is beschikbaar",
            "invalid": "Terug url is ongeldig"
        },
        "logo": {
            "required": "Logo is verplicht",
            "dimensions": "Logo moet minimaal 500 X 500 px zijn en een beeldverhouding van 1:1 hebben, JPG/JPEG/PNG-formaten worden ondersteund.",
            "choose": "Kies alstublieft een afbeelding",
            "file": "Upload alstublieft JPG- of PNG-formaten, minimale resolutie 500 X 500 px en beeldverhouding 1:1. Max grootte 2MB"
        },
        "background_image": {
            "dimensions": "Achtergrondafbeelding moet minimaal 1000 X 1000 px zijn en een beeldverhouding van 1:1 hebben, JPG/JPEG/PNG-formaten worden ondersteund.",
            "choose": "Kies alstublieft een afbeelding",
            "file": "Upload alstublieft JPG- of PNG-formaten, minimale resolutie 1000 X 1000 px en beeldverhouding 1:1. Max grootte 5MB"
        },
        "social_link_destination_url_facebook": {
            "required": "Bestemmings-Url is verplicht",
            "regexp": "Ongeldige Url",
            "invalid": "Ongeldige Facebook Url"
        },
        "social_link_destination_url_instagram": {
            "required": "Bestemmings-Url is verplicht",
            "regexp": "Ongeldige Url",
            "invalid": "Ongeldige Instagram Url"
        },
        "social_link_destination_url_twitter": {
            "required": "Bestemmings-Url is verplicht",
            "regexp": "Ongeldige Url",
            "invalid": "Ongeldige Twitter Url"
        },
        "social_link_destination_url_youtube": {
            "required": "Bestemmings-Url is verplicht",
            "regexp": "Ongeldige Url",
            "invalid": "Ongeldige Youtube Url"
        },
        "social_link_destination_url_tiktok": {
            "required": "Bestemmings-Url is verplicht",
            "regexp": "Ongeldige Url",
            "invalid": "Ongeldige TikTok Url"
        },
        "social_link_destination_url_linkedin": {
            "required": "Bestemmings-Url is verplicht",
            "regexp": "Ongeldige Url",
            "invalid": "Ongeldige LinkedIn Url"
        },
        "social_link_destination_url_other": {
            "regexp": "Ongeldige Url"
        },
        "featured_link_title": {
            "required": "Label is verplicht",
            "length": "Label mag niet langer zijn dan 100 tekens"
        },
        "featured_link_destination_url": {
            "required": "Bestemmings-Url is verplicht",
            "regexp": "Ongeldige Url"
        }
    }
};

export default linkLandingPagesValidationNL;